/* eslint-disable import/no-unresolved */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/self-closing-comp */
import React, { useRef } from 'react';
import './css/Operators.css';
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import Tez from '../../../images/tez-logo-r.webp';
import FS from '../../../images/fun-logo-r.webp';
import Anex from '../../../images/anex-logo-r.webp';
import InterCity from '../../../images/inter-logo-r.webp';
import Coral from '../../../images/coral-logo-r.webp';
import RussianExp from '../../../images/russian-exp-logo-r.webp';
import Pegas from '../../../images/pegas-logo-r.webp';
import VoyageT from '../../../images/voyaj-logo-r.webp';
import AeroTravel from '../../../images/aerotravel-logo-r.webp';
import Rosting from '../../../images/rosting-logo-r.webp';
import TimeV from '../../../images/timevoyaj-logo-r.webp';
import CentrCyrort from '../../../images/chentr-logo-r.webp';
import Top from '../../../images/top-logo-r.webp';
import AeroBel from '../../../images/aerobel-logo-r.webp';
import Alatan from '../../../images/alatan-r.webp';
import Vogue from '../../../images/voyajtravel-logo-r.webp';
import Sunmar from '../../../images/sunmar-logo-r.webp';
import Compas from '../../../images/compas-logo-r.webp';

function Operators() {
  const swiperRef = useRef(null);

  const slideLeft = (ref) => {
    if (ref.current) {
      ref.current.slideNext();
    }
  };

  const slideRight = (ref) => {
    if (ref.current) {
      ref.current.slidePrev();
    }
  };

  const getSwiperItems = (quantity, ref) => (
    <Swiper
      modules={[Pagination, Scrollbar, A11y]}
      spaceBetween={0}
      slidesPerView={quantity}
      scrollbar={{ draggable: true }}
      onSwiper={(swiper) => {
        ref.current = swiper;
      }}
      breakpoints={{
        500: {
          slidesPerView: 4,
        },
        1040: {
          slidesPerView: 5,
        },
        1280: {
          slidesPerView: 6,
        },
        1440: {
          slidesPerView: 7,
        },
      }}
    >
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="tez_logo" src={Tez} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="fun_logo" src={FS} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="anex_logo" src={Anex} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="intercity_logo" src={InterCity} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="coral_logo" src={Coral} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="rusexp_logo" src={RussianExp} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="voyage_logo" src={VoyageT} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="rosting_logo" src={Rosting} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="pegas_logo" src={Pegas} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="aero_logo" src={AeroTravel} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="time_logo" src={TimeV} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="top_logo" src={Top} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="centr_logo" src={CentrCyrort} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="aerobel_logo" src={AeroBel} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="alatan_logo" src={Alatan} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="vogue_logo" src={Vogue} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="sunmar_logo" src={Sunmar} alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="swiper_item_w">
          <img className="compas_logo" src={Compas} alt="" />
        </div>
      </SwiperSlide>
    </Swiper>
  );

  const getSwiperContent = (quantity, ref) => (
    <div className="operators_line">
      <button
        type="button"
        className="operators_swipe_button_left"
        onClick={() => slideRight(ref)}
      ></button>
      <div className="operator_swiper_w">{getSwiperItems(quantity, ref)}</div>
      <button
        type="button"
        className="operators_swipe_button_righ"
        onClick={() => slideLeft(ref)}
      ></button>
    </div>
  );

  return (
    <div className="operators_w">
      <div className="containerW">
        <div>{getSwiperContent(3, swiperRef)}</div>
      </div>
    </div>
  );
}

export default Operators;
